module.exports = __webpack_public_path__ + "img/G.2b65f32.jpg";